import { useState, useEffect, useMemo } from 'react';
import customHeaders, { getSpace } from '../../../../../common/headers';
import { TitlePage } from '../../../../../components/TitlePage/TitlePage';
import { ButtonBasic, InputDinamycPlaceholder, DropDownSelector } from "@lk-gtcom/ecomlab-components";
import useGeneralStore from '../../../../../store/general';
import { DynamicFormComponent } from '../../../../../components/DynamicFormComponent/DynamicFormComponent';
import { ModalAddElementsDict } from './ModalAddElementsDict/ModalAddElementsDict';
import { ModalComponent } from '../../../../../components/Modal/ModalComponent/ModalComponent';
import { useResponseHandler } from '../../../../../common/auth';
import { ButtonWithIcon } from '../../../../../components/Buttons/ButtonWithIcon/ButtonWithIcon';
import settings_icon from './img/setting.svg'
import './ModalAddFields.scss';

interface ModalAddFieldsProps {
    setIsModal: (isModal: boolean) => void
    stringUrl: 'contracts' | 'services' | 'companies' | 'contacts'
}

interface DataField {
    name: string;
    id: string | number;
    type: string;
    possible_values: string[];
}

const TYPE_LIST = [
    { label: 'Строка', value: 'string' },
    { label: 'Чекбокс', value: 'bool' },
    { label: 'Число', value: 'int' },
    { label: 'Дробное число', value: 'float' },
    { label: 'Список с выбором значений', value: 'dict' },
    { label: 'Проценты', value: 'percent' },
    { label: 'Теги', value: 'array' },
    { label: 'Поле ввода для текста', value: 'field' },
]

const ModalAddFields = ({
    setIsModal,
    stringUrl
}: ModalAddFieldsProps) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    const { handleStatusCode, handleTableResponse, handleRequestError } = useResponseHandler();

    // Поля 
    const [selectedType, setSelectedType] = useState(TYPE_LIST[0])
    const [fieldsdName, setFieldsName] = useState('')
    const [fields, setFilds] = useState([])
    const [fieldsArr, setFieldsArr] = useState([])
    const [loading, setLoading] = useState(true)
    const [listDict, setListDict] = useState([])

    // Модалка
    const [isModalAddElementsDict, setIsModalAddElementsDict] = useState(false)

    // Добавление полей
    const addFields = (fieldsdName: string) => {
        fetchAddAdditionalFieldsProject(fieldsdName)
        setFieldsName('');
    };

    // Получение полей
    const fetchGetAdditionalFields = (abortController = new AbortController()) => {
        let url = `https://portals.ecomru.ru/api/crm/${stringUrl}/get/additional_fields`

        fetch(url, { method: 'GET', headers, signal: abortController.signal })
            .then(handleTableResponse)
            .then((json) => {
                setFieldsArr(json);
                setFilds(json?.map(({ name, id, type, possible_values }: DataField) => {
                    return {
                        front_name: name,
                        data_type: type,
                        id: id,
                        possible_values:
                            possible_values || []
                    }
                }))
            })
            .catch(handleRequestError)
            .finally(() => setLoading(false))
    };

    // Добавление доп полей к проекту
    const fetchAddAdditionalFieldsProject = (name: string) => {
        let url = `https://portals.ecomru.ru/api/crm/${stringUrl}/additional_field`

        const body = JSON.stringify({
            name: name,
            type: selectedType?.value,
            possible_values: listDict
        });

        fetch(url, { method: 'POST', headers, body })
            .then(handleTableResponse)
            .then(json => {
                setTimeout(() => fetchGetAdditionalFields(), 500)
                setListDict([])
            })
            .catch(handleRequestError);
    };

    // Изменение доп полей к проекту
    const fetchChangeAdditionalFieldsProject = (name: string, id: number | string, type: string, before: null | number | string = null, possible_values: [] | undefined) => {
        let url = `https://portals.ecomru.ru/api/crm/${stringUrl}/additional_field`

        const body = JSON.stringify({
            name: name,
            type: type,
            field_id: id,
            possible_values,
            before
        });

        fetch(url, { method: 'PATCH', headers, body })
            .then(handleTableResponse)
            .then(json => setTimeout(() => fetchGetAdditionalFields(), 500))
            .catch(handleRequestError);
    };

    // Удаление поля
    const fetchDeleteAdditionalFieldsProject = (id: number | string) => {
        let url = `https://portals.ecomru.ru/api/crm/${stringUrl}/additional_field/delete?field_id=${id}`

        fetch(url, { method: 'DELETE', headers })
            .then(handleTableResponse)
            .then(json => setTimeout(() => fetchGetAdditionalFields(), 500))
            .catch(handleRequestError);
    };

    useEffect(() => {
        fetchGetAdditionalFields();
    }, []);

    return (
        <>
            {isModalAddElementsDict &&
                <ModalAddElementsDict
                    list={listDict}
                    setList={setListDict}
                    setIsModal={setIsModalAddElementsDict}
                />}

            <ModalComponent
                onClose={e => setIsModal(false)}
                title={'Добавление полей'}
                loading={loading}
                style={{
                    maxWidth: '1000px',
                    minHeight: '600px',
                    height: 'auto'
                }}
                child={
                    <div className="modal-add-fields-crm-v2">
                        <div className="modal-add-fields-crm-v2__request-list">
                            <div className='modal-add-fields-crm-v2__fields'>
                                <div className="modal-add-fields-crm-v2__fields-row">
                                    <InputDinamycPlaceholder
                                        changeValue={fieldsdName}
                                        onChange={setFieldsName}
                                        placeholder="Введите название поля"
                                        size="s"
                                    />

                                    <DropDownSelector
                                        options_prop={TYPE_LIST}
                                        state={selectedType}
                                        setState={setSelectedType}
                                        placeholder="Тип поля"
                                        isClearable={false}
                                    />

                                    {selectedType?.value === 'dict' && <ButtonWithIcon
                                        grey
                                        disabled={selectedType?.value !== 'dict'}
                                        size='m'
                                        icon={settings_icon}
                                        onClick={() => setIsModalAddElementsDict(true)}
                                    />}

                                    <ButtonBasic
                                        green
                                        text="Создать"
                                        onClick={() => {
                                            if (fieldsdName?.length > 0) {
                                                addFields(fieldsdName);
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="modal-add-fields-crm-v2__fields-group">
                                <TitlePage
                                    medium
                                    title={'Готовые поля'}
                                />

                                <div className="modal-add-fields-crm-v2__fields-content">
                                    <DynamicFormComponent
                                        productTemporary={fields}
                                        fetchDelete={fetchDeleteAdditionalFieldsProject as any}
                                        fetchChange={fetchChangeAdditionalFieldsProject as any}
                                        isEdit={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                }
            />
        </>
    );
};

export { ModalAddFields };